import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';

export default class ClassManagePage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      classes: [],
      schoolId: null,
      info: "",
      graduatedArray: [],
      showGraduated: false
    };
    // bind this
    this.toClassDetail = this.toClassDetail.bind(this);
  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let path = window.location.href;
    let schoolId;
    let info;
    if(this.state.role.associatName == 'school'){
      schoolId = this.state.role.associatObj.id;
    }else {
      schoolId = this.state.role.associatObj.schoolId;
    }
    if(path.indexOf('album') >= 0){
      info = "album"
    }else if(path.indexOf('record') >=0 ){
      info = "file"
    }
    this.setState({
      schoolId: schoolId
    })
    let data = {
      school_id: schoolId,
      info: info
    }
    this.loadClasses(data);
  }

  componentWillReceiveProps(nextProps){
    let path = nextProps.location.pathname;
    let info = '';
    if(path.indexOf('album') >= 0){
      info = 'album'
    }else if(path.indexOf('record') >=0 ){
      info = 'file'
    }
    let data = {
      school_id: this.state.schoolId,
      info: info
    }
    this.loadClasses(data);
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  loadClasses(data){
    let that = this;
    DataService.getClassList(data).then((classes) => {
      let classGradeListTemp = {};
      let classGradeList = [], graduatedArray = [];
      classes.forEach(function(classItem){
        if (classGradeListTemp["grade_id" + classItem.class_grade_id]){
          classGradeListTemp["grade_id" + classItem.class_grade_id].classList.push(classItem)
        } else {
          classGradeListTemp["grade_id" + classItem.class_grade_id] = {
            id: classItem.class_grade_id,
            name: classItem.grade_name,
            is_graduated: classItem.is_graduated,
            graduate_date: classItem.graduate_date,
            classList: [classItem],
          }
        }
      })
      for (let item in classGradeListTemp) {
        if (classGradeListTemp[item] && !classGradeListTemp[item].is_graduated){
          classGradeList.push(classGradeListTemp[item])
        } else {
          graduatedArray.push(classGradeListTemp[item])
        }
      }
      if(that.state.role.associatName == 'classGrade'){
        let classGradeListGrade = [];
        classGradeListGrade.push(classGradeList.find(function(grade){
          return grade.id == that.state.role.associatObj.id
        }))
        
        this.setState({
          classes: classGradeListGrade,
          graduatedArray: graduatedArray.filter((grade) => grade.id == that.state.role.associatObj.id),
          schoolId: data.school_id,
          info: data.info,
        });
      }else {
        this.setState({
          classes: classGradeList,
          graduatedArray,
          schoolId: data.school_id,
          info: data.info,
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  toClassDetail(e){
    let classId = e.currentTarget.dataset.id;
    let info = this.state.info;
    if(info == "album"){
      hashHistory.push(`albums/index?classId=${classId}`)
    }else if(info == "file" ){
      hashHistory.push(`record/index?classId=${classId}`)
    }
  }

  render() {
    return (
      <div className="albums-manage-page">
        <div className="classes-wrapper">
          {this.state.classes.map(grade =>
            <div key={grade.id} style={{marginBottom:'40px'}}>
              <div className="class-grade">{grade.name}</div>
              {grade.classList.map(classItem =>
                <div className="class-box" key={classItem.id} data-id={classItem.id} onClick={this.toClassDetail}>
                  <div className="class-box-name" >{classItem.name}</div>
                  {(this.state.info == 'album') && <div className="class-box-info" >共有{classItem.album_count}个相册</div>}
                  {(this.state.info == 'file') && <div className="class-box-info" >共有{classItem.photo_count}张照片 {classItem.video_count}个视频</div>}
                </div>
              )}
            </div>
          )}
          <div style={{ color: '#4DA1FF', marginBottom: '20px', cursor: 'pointer'}} onClick={() => this.setState({ showGraduated: !this.state.showGraduated })}>{this.state.showGraduated ? '收起' : '查看'}毕业班级</div>
          {this.state.showGraduated && this.state.graduatedArray.map(grade =>
            <div key={grade.id} style={{ marginBottom: '40px' }}>
              <div className="class-grade">{grade.name} - {this.toolGraduatedDate(grade.graduate_date)}毕业</div>
              {grade.classList.map(classItem =>
                <div className="class-box" key={classItem.id} data-id={classItem.id} onClick={this.toClassDetail}>
                  <div className="class-box-name" >{classItem.name}</div>
                  {(this.state.info == 'album') && <div className="class-box-info" >共有{classItem.album_count}个相册</div>}
                  {(this.state.info == 'file') && <div className="class-box-info" >共有{classItem.photo_count}张照片 {classItem.video_count}个视频</div>}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/ClassManagePage.jsx